// Desc: Generic Profile Page
import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useStepIndicator } from '../../components/StepIndicator';
import { FormProvider, useFieldArray, useForm } from 'react-hook-form';
import TextInput2 from '../../components/form-elements/TexInput2/TextInput2';
import Button from '../../components/button/button';
import {
  configuration,
  createbodybc,
  createbodyenad,
  dataToFormDataBC,
  dataToFormDataEnad,
  prompt_objetivos,
  prompt_objetivos_modificar,
} from './config';
import { extractOptions } from '../../services/chat.service';
import {
  HeaderFormWithSteps,
  OptionsViwer,
  ScreenForm,
  SelectLevel,
  InputValidator,
  CardObjective,
  SelectType,
  ScreenViewEdit,
  GeneralFormT1,
  ObjectivesFormT1,
  ModalObjectives,
  SkeletonClass,
  NotFound,
} from './components';
import {
  useFormGroupEnadStep2,
  useFormGroupObjectives,
  useMutationCourse,
  useMutationGetClassProfile,
  useUtilsNavigation,
  useUtilsSelectEnad,
} from './hooks';
import { TabsComponent, useTabsComponent } from '../../components/TabsMenu';
import { SelectableInput } from '../../components/Select';
import {
  AvailableSoon,
  HeaderInputComponent,
  HeaderScreenPath,
} from '../../components/Labels';
import { Modal, useModal } from '../../components/form-elements/Modals';
import shaia from '../../assets/new_shaia.png';
import classNames from 'classnames';
import { updateClassProfileJson } from '../../services/profile-class.service';
import { useSwitchInstitution } from '../../hooks/useIntitution';
import { Trancripts } from '../enad/FeedBack';
import { LevelsEnglishViewer } from '../custom_superpowers/british_council/LevelsEnglish';
// modificar_objetivos

/********************ENAD******************/
/**
 * Paso 1 del formulario de creacion de grupo enad
 * @param {*} param0
 * @returns
 */
export const FormGroupEnadStep1 = ({
  currentOption,
  methods,
  arrayFields,
  readonly = false,
}) => {
  const {
    optionsArea,
    groupingType,
    optionstype,
    optionsLevel,
    t,
    resetlevels,
  } = useUtilsSelectEnad({ config: configuration, methods, arrayFields });
  return (
    <div>
      <TextInput2
        HeaderComponent={() => (
          <HeaderInputComponent
            viewmode={readonly}
            labelkey='group_name'
            labelInstruction={
              readonly
                ? null
                : 'enter_the_name_you_want_to_identify_this_group_with_next_structure'
            }
            labelInstructio2ex={
              readonly
                ? null
                : 'enter_the_name_you_want_to_identify_this_group_with_next_structure_ex'
            }
          />
        )}
        name='name'
        placeHolder={t('example_group_01_morning_shift')}
        maxLength={'60'}
        customClassName={'mt-0'}
        classNameLabel='p-0'
        classNameInstruction='px-0'
        required
        viewmode={readonly}
      />
      <div className='flex flex-wrap gap-2 mb-8'>
        <div className='flex-1 min-w-[200px]'>
          <SelectableInput
            rules={{ required: t('campo_requerido') }}
            placeHolder={t('teaching_area_placeholder')}
            label={t('teaching_area')}
            labelInstruction={t('teaching_area_instruction') + '.'}
            name={'area'}
            onChange={resetlevels}
            options={optionsArea}
            isDisabled={readonly}
            viewmode={readonly}
          />
        </div>
        <div className='flex-1 min-w-[200px]'>
          <SelectableInput
            rules={{ required: t('campo_requerido') }}
            placeHolder={t('student_grouping_type_placeholder')}
            label={t('student_grouping_type')}
            labelInstruction={t('student_grouping_type_instruction') + '.'}
            name={'groupingType'}
            onChange={resetlevels}
            options={optionstype}
            isDisabled={readonly}
            viewmode={readonly}
          />
        </div>
      </div>
      <SelectLevel
        howmanystudentskey={groupingType?.questionkey}
        labelkey={groupingType?.labelkey}
        instructionkey={groupingType?.intructionskey}
        optionsLevel={optionsLevel}
        methods={methods}
        limit={groupingType?.limit}
        arrayFields={arrayFields}
        fieldArraylevels={arrayFields.fieldArraylevels}
        viewmode={readonly}
      />
      <SelectableInput
        rules={{ required: t('campo_requerido') }}
        placeHolder={t('select_or_create_details')}
        label={t('additional_context')}
        labelInstruction={t('share_key_details') + ':'}
        labelInstructio2={`"${t('students_demotivate_easily')}."`}
        name={'considerations'}
        isMulti
        options={[]}
        viewmode={readonly}
        isDisabled={readonly}
      />
    </div>
  );
};

/**
 * paso 2 del formulario de creacion de grupo enad
 * @param {*} param0
 * @returns
 */
export const FormGroupEnadStep2 = ({
  currentOption,
  methods,
  arrayFields,
  ButtonsControls,
}) => {
  const {
    t,
    loading,
    validate,
    headers,
    onClickHaveAnotherOption,
    haveNewOptions,
    onClickGenerateNewOptions,
    setOptionModify,
    optionModify,
    options,
    resetOptions,
    objetivesOptions,
    removeobjetivesOptions,
    modifyObjetives,
  } = useFormGroupEnadStep2({
    arrayFields,
    methods,
    promptObjetivos: prompt_objetivos,
    promptobjetivosmodificar: prompt_objetivos_modificar,
    extractOptionsfn: extractOptions,
  });
  const currentArea = methods.getValues("area")
  let enadObjectivePlaceholder = "";
  if (haveNewOptions) {
    enadObjectivePlaceholder = 'share_learning_objective_ideas'
  }
  if (!haveNewOptions && currentArea?.value === "Lectura") {
    enadObjectivePlaceholder = 'enad_objectives_example_lectura'
  }
  if (!haveNewOptions && currentArea?.value === "Matemáticas") {
    enadObjectivePlaceholder = 'enad_objectives_example_matematica'
  }
  if (optionModify)
    return (
      <>
        <InputValidator
          labelinput='enad_objectives'
          placeHolder='example_real_life_objectives'
          name='ideas'
          buttonlabel='modify_objective'
          loadindicatorlabel='please_wait'
          onClick={() => modifyObjetives({ ...optionModify })}
          showOnlyheader={loading}
          disabledInput={loading}
          loading={loading}
          labelInstruction={t('understood_lets_modify_the_option', {
            option: optionModify.index + 1,
          })}
          labelInstructio2={`"${optionModify?.option?.option?.[0] ?? ''}"`}
          labelInstructio3={loading ? '' : 'modify_objective_idea'}
        />
        <ButtonsControls hiddenskip disabledButtons={loading} />
      </>
    );

  if (options?.length)
    return (
      <OptionsViwer
        headers={headers}
        loading={loading}
        objectiveskey='enad_objectives'
        objectivessesionkey='objetivo_sesion_enad'
        options={options}
        methods={methods}
        resetOptions={resetOptions}
        arrayFields={arrayFields}
        modifyObjetives={setOptionModify}
        onClickHaveAnotherOption={onClickHaveAnotherOption}
        fieldArrayObjetivesOptions={arrayFields.fieldArrayObjetivesOptions}
        onClickGenerateNewOptions={onClickGenerateNewOptions}
        ButtonsControls={() => (
          <ButtonsControls hiddenskip disabledButtons={loading} />
        )}
      />
    );
  return (
    <>
      <div>
        <InputValidator
          labelinput='enad_objectives'
          labelInstruction={
            haveNewOptions
              ? 'share_learning_objective_ideas'
              : 'enad_objectives_instructions'
          }
          labelInstructio3={
            haveNewOptions ? null : 'create_objectives_during_sessions'
          }
          placeHolder={enadObjectivePlaceholder}
          name='objectives'
          buttonlabel='validate_objective'
          loadindicatorlabel='validating_objective'
          onClick={validate}
          disabledInput={loading}
          loading={loading}
        />
        <div className='grid gap-[16px] mt-4'>
          {objetivesOptions.length ? (
            <div className='text-Yellow-300 py-[5px] font-bold text-[18px] px-[8px] border-0 border-l-4 border-Yellow-300'>
              {t('added_objectives')}
            </div>
          ) : null}
          {objetivesOptions.map((option, index) => {
            return (
              <CardObjective
                key={index}
                option={option}
                removeobjetivesOptions={removeobjetivesOptions}
              />
            );
          })}
        </div>
      </div>
      <ButtonsControls
        hiddenskip={objetivesOptions?.length}
        disabledButtons={loading}
      />
    </>
  );
};

/**
 * Formulario de creacion de grupo enad
 * @param {*} param0
 * @returns
 */
export const FormGroupEnad = ({
  currentOption,
  currentStep,
  nextStep,
  prevStep,
  onsuccess
}) => {
  const { loading, send } = useMutationCourse({ createbody: createbodyenad, onsuccess });
  const methods = useForm({ mode: 'onBlur' });

  const fieldArraylevels = useFieldArray({
    control: methods.control,
    name: 'levels',
  });

  const fieldArrayObjetivesOptions = useFieldArray({
    control: methods.control,
    name: 'objetivesOptions',
  });

  const arrayFields = useMemo(
    () => ({ fieldArraylevels, fieldArrayObjetivesOptions }),
    [fieldArraylevels, fieldArrayObjetivesOptions]
  );

  const { name, area, groupingType, levels, considerations } = methods.watch();

  const disabledStep1 = useMemo(() => {
    return (
      !name ||
      !area ||
      !groupingType ||
      !levels?.length ||
      !considerations?.length
    );
  }, [name, area, groupingType, levels, considerations]);

  const { t } = useTranslation();

  /* Ir a el siguiente paso */
  const handleNextStep = (evt) => {
    methods.trigger().then(() => {
      if (!Object.keys(methods.formState.errors)?.length) nextStep(evt);
    });
  };

  //Enviar el formulario
  const handleOnsubmit = () => {
    methods.handleSubmit(send)();
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(send)} className='w-full'>
        {currentStep === 1 ? (
          <>
            <FormGroupEnadStep1
              currentOption={currentOption}
              methods={methods}
              arrayFields={arrayFields}
            />
            <div className='flex justify-center mt-4'>
              <Button
                label={t('next')}
                variant='primary'
                typeB='button'
                disabled={disabledStep1}
                onClick={handleNextStep}
              />
            </div>
          </>
        ) : null}
        {currentStep === 2 ? (
          <FormGroupEnadStep2
            ButtonsControls={({ hiddenskip, disabledButtons }) => (
              <>
                <div className='sm:grid md:flex flex-wrap mt-4 gap-3'>
                  <div className='hidden md:block flex-1'></div>
                  <div className='flex flex-1 justify-center gap-[16px]'>
                    <Button
                      label={t('previous')}
                      variant='primary-outline'
                      typeB='button'
                      disabled={disabledButtons}
                      onClick={prevStep}
                    />
                    <Button
                      label={t('create_group')}
                      variant='primary'
                      typeB={'button'}
                      onClick={handleOnsubmit}
                      disabled={
                        loading ||
                        disabledButtons ||
                        !fieldArrayObjetivesOptions?.fields?.length
                      }
                    />
                  </div>
                  <div className='flex flex-1 justify-center md:justify-end py-[8px] md:py-[0px]'>
                    {!hiddenskip ? (
                      <Button
                        label={t('skip_and_create_group')}
                        variant='primary'
                        typeB={'button'}
                        onClick={handleOnsubmit}
                        disabled={disabledButtons}
                      />
                    ) : null}
                  </div>
                </div>
              </>
            )}
            currentOption={currentOption}
            methods={methods}
            arrayFields={arrayFields}
          />
        ) : null}
      </form>
    </FormProvider>
  );
};

/**
 * Pantalla de creacion de grupo enad
 * @param {*} param0
 * @returns
 */
export const GroupEnad = ({ config, onsuccess }) => {
  const { bind, currentStep, setCurrentStep } = useStepIndicator({
    steps: 2,
    steplong: 'w-[40px]',
  });
  const { type, currentOption } = useUtilsNavigation({ menu: config.menu });

  const handleNextStep = (step) => () => {
    setCurrentStep(currentStep + step);
  };

  return (
    <ScreenForm>
      <HeaderFormWithSteps
        step={currentStep}
        bindstep={bind}
        option={currentOption?.title?.toLowerCase() ?? ''}
      />
      <FormGroupEnad
        type={type}
        currentOption={currentOption}
        currentStep={currentStep}
        prevStep={handleNextStep(-1)}
        nextStep={handleNextStep(1)}
        onsuccess={onsuccess}
      />
    </ScreenForm>
  );
};

/**
 * Pantalla de edicion de grupo enad
 * @param {*} param0
 * @returns
 */
export const GeneralInformationEnad = ({ dataForm, onsuccess, id }) => {
  const { send, t, readonly, changeReadOnly } = useMutationCourse({
    createbody: createbodyenad,
    defaultreadonly: true,
    onsuccess:
      ({ changeReadOnly: _changeReadOnly, show }) =>
        () => {
          _changeReadOnly();
          show('success');
          onsuccess();
        },
    useid: true,
    mutationFn: updateClassProfileJson,
  });

  const methods = useForm({ mode: 'onBlur' });
  const { reset } = methods;

  const fieldArraylevels = useFieldArray({
    control: methods.control,
    name: 'levels',
  });

  //Cada vez que se cambia el read only se reinicia el formulario
  useEffect(() => {
    reset(dataForm);
  }, [dataForm, readonly, reset]);

  const _send = (data) => {
    send({ id, ...data });
  };

  const arrayFields = useMemo(() => ({ fieldArraylevels }), [fieldArraylevels]);

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(_send)}
        className='w-full flex flex-col justify-center'
      >
        <FormGroupEnadStep1
          readonly={readonly}
          currentOption={1}
          methods={methods}
          arrayFields={arrayFields}
        />
        <div className='flex w-full gap-[16px] justify-center'>
          {readonly ? (
            <Button
              label={t('edit')}
              variant='primary'
              typeB='button'
              onClick={() => changeReadOnly()}
            />
          ) : (
            <>
              <Button
                label={t('editor_actividad_boton_cerrar')}
                variant='primary'
                typeB='button'
                onClick={() => changeReadOnly()}
              />
              <Button label={t('perfil_guardar')} variant='secondary' />
            </>
          )}
        </div>
      </form>
    </FormProvider>
  );
};

export const ModalObjectivesEnad = ({
  methods,
  afterAppend,
  arrayFields,
  loading,
  modifyObjetives,
  validate,
  headers,
  onClickHaveAnotherOption,
  haveNewOptions,
  onClickGenerateNewOptions,
  setOptionModify,
  optionModify,
  options,
  resetOptions,
}) => {
  const { openModal, bind, t, closeModal } = useModal();
  const _afterAppend = () => {
    afterAppend?.();
    closeModal();
  };
  return (
    <>
      <Button
        label={t('create_a_new_one')}
        variant='primary'
        typeB={'button'}
        customClassName='whitespace-nowrap'
        onClick={openModal}
      />
      <Modal
        customClass={classNames('max-h-[800px] w-[700px]', {
          'w-fit': options?.length && !optionModify,
        })}
        {...bind}
      >
        <div className='flex w-full items-center gap-[8px]'>
          <img
            src={shaia}
            className='w-[24px] h-[24px] rounded-[78px]'
            alt='Sha.ia'
          />
          <HeaderInputComponent labelkey='Shaia' />
        </div>
        <div className='max-h-[650px] overflow-auto'>
          {optionModify ? (
            <>
              <InputValidator
                labelinput='enad_objectives'
                placeHolder='example_real_life_objectives'
                name='ideas'
                buttonlabel='modify_objective'
                loadindicatorlabel='please_wait'
                onClick={() => modifyObjetives({ ...optionModify })}
                showOnlyheader={loading}
                disabledInput={loading}
                loading={loading}
                labelInstruction={t('understood_lets_modify_the_option', {
                  option: optionModify.index + 1,
                })}
                labelInstructio2={`"${optionModify?.option?.option?.[0] ?? ''
                  }"`}
                labelInstructio3={loading ? '' : 'modify_objective_idea'}
                classNameInput={'mt-0'}
              />
            </>
          ) : options?.length ? (
            <OptionsViwer
              headers={headers}
              loading={loading}
              objectiveskey='enad_objectives'
              objectivessesionkey='objetivo_sesion_enad'
              options={options}
              methods={methods}
              resetOptions={resetOptions}
              arrayFields={arrayFields}
              modifyObjetives={setOptionModify}
              onClickHaveAnotherOption={onClickHaveAnotherOption}
              fieldArrayObjetivesOptions={
                arrayFields.fieldArrayObjetivesOptions
              }
              onClickGenerateNewOptions={onClickGenerateNewOptions}
              ButtonsControls={() => null}
              afterAppend={_afterAppend}
            />
          ) : (
            <InputValidator
              labelinput='enad_objectives'
              labelInstruction={
                haveNewOptions
                  ? 'share_learning_objective_ideas'
                  : 'enad_objectives_instructions'
              }
              labelInstructio3={
                haveNewOptions ? null : 'create_objectives_during_sessions'
              }
              placeHolder={
                haveNewOptions
                  ? 'example_critical_thinking_skills'
                  : 'enad_objectives_example'
              }
              name='objectives'
              buttonlabel='validate_objective'
              loadindicatorlabel='validating_objective'
              onClick={validate}
              disabledInput={loading}
              loading={loading}
              classNameInput={'mt-0'}
            />
          )}
        </div>
        <div className='flex w-full justify-center items-center mt-4'>
          <Button
            label={t('close')}
            variant='primary-outline'
            typeB='button'
            onClick={closeModal}
          />
        </div>
      </Modal>
    </>
  );
};

/**
 * Componente para mostrar la vista de objetivos
 * @param {*} param0
 * @returns
 */
export const FormViewGroupObjetives = ({
  methods,
  arrayFields,
  dataForm,
  forceSubmit,
}) => {
  const bind = useFormGroupEnadStep2({
    arrayFields,
    methods,
    promptObjetivos: prompt_objetivos,
    promptobjetivosmodificar: prompt_objetivos_modificar,
    extractOptionsfn: extractOptions,
  });
  const { removeobjetivesOptions } = bind;

  const _removeobjetivesOptions = (id) => {
    removeobjetivesOptions(id);
    forceSubmit();
  };

  return (
    <>
      <div>
        <div className='grid gap-[16px] mt-8'>
          <div className='flex justify-between'>
            <HeaderInputComponent labelkey='objectives_defined_for_this_group' />
            <ModalObjectivesEnad
              afterAppend={forceSubmit}
              {...bind}
              {...{ methods, arrayFields }}
            />
          </div>
          {bind?.objetivesOptions?.map((option, index) => {
            return (
              <CardObjective
                key={index}
                option={option}
                removeobjetivesOptions={_removeobjetivesOptions}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export const LearningObjectives = ({ onsuccess, dataForm, id }) => {
  const { send } = useMutationCourse({
    createbody: createbodyenad,
    defaultreadonly: true,
    onsuccess:
      ({ changeReadOnly: _changeReadOnly, show }) =>
        () => {
          _changeReadOnly();
          show('success');
          onsuccess();
        },
    useid: true,
    mutationFn: updateClassProfileJson,
  });
  const methods = useForm({ mode: 'onBlur' });
  const { reset } = methods;

  const fieldArrayObjetivesOptions = useFieldArray({
    control: methods.control,
    name: 'objetivesOptions',
  });

  useEffect(() => {
    reset(dataForm);
  }, [dataForm, reset]);

  const _send = (data) => {
    send({ id, ...data });
  };

  const forceSubmit = () => {
    methods.handleSubmit(_send)();
  };

  const arrayFields = useMemo(
    () => ({ fieldArrayObjetivesOptions }),
    [fieldArrayObjetivesOptions]
  );

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(_send)} className='w-full'>
        <FormViewGroupObjetives
          methods={methods}
          dataForm={dataForm}
          forceSubmit={forceSubmit}
          arrayFields={arrayFields}
        />
      </form>
    </FormProvider>
  );
};

/**
 * Pantalla de edicion de grupo enad
 * @param {*} param0
 * @returns
 */
export const GeneralInformationBC = ({ dataForm, onsuccess, id }) => {
  const { send, t, readonly, changeReadOnly } = useMutationCourse({
    createbody: createbodybc,
    defaultreadonly: true,
    onsuccess:
      ({ changeReadOnly: _changeReadOnly, show }) =>
        () => {
          _changeReadOnly();
          show('success');
          onsuccess();
        },
    useid: true,
    mutationFn: updateClassProfileJson,
  });

  const methods = useForm({ mode: 'onBlur' });
  const { reset } = methods;

  const fieldArraylevels = useFieldArray({
    control: methods.control,
    name: 'levels',
  });

  //Cada vez que se cambia el read only se reinicia el formulario
  useEffect(() => {
    reset(dataForm);
  }, [dataForm, readonly, reset]);

  const _send = (data) => {
    send({ id, ...data });
  };

  const arrayFields = useMemo(() => ({ fieldArraylevels }), [fieldArraylevels]);

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(_send)}
        className='w-full flex flex-col justify-center'
      >
        <FormGroupBCStep1
          readonly={readonly}
          currentOption={1}
          methods={methods}
          arrayFields={arrayFields}
        />
        <div className='flex w-full gap-[16px] justify-center'>
          {readonly ? (
            <Button
              label={t('edit')}
              variant='primary'
              typeB='button'
              onClick={() => changeReadOnly()}
            />
          ) : (
            <>
              <Button
                label={t('editor_actividad_boton_cerrar')}
                variant='primary'
                typeB='button'
                onClick={() => changeReadOnly()}
              />
              <Button label={t('perfil_guardar')} variant='secondary' />
            </>
          )}
        </div>
      </form>
    </FormProvider>
  );
};

/**
 * View Edit Group para el perfil de grupo enad
 * @returns
 */
export const ViewEditGroup = () => {
  const { bind } = useTabsComponent({ defaultIndex: 0 });
  const { mutate, dataForm, isLoading, isError, config } =
    useMutationGetClassProfile({
      config: configuration,
      dataToFormDatafn: dataToFormDataEnad,
    });
  const { id } = useUtilsNavigation({});

  // Se obtiene la informacion del grupo
  const getData = useCallback(() => {
    if (id && config) {
      mutate({ id });
    }
  }, [id, mutate, config]);

  useEffect(() => {
    getData();
  }, [getData]);

  if (isError && !isLoading)
    return <h1>Error, No se puedo obtener el recuso</h1>;

  return (
    <ScreenViewEdit>
      <HeaderScreenPath path='/course-profile' name={dataForm?.name} />
      <TabsComponent
        customClassTabList='min-w-[700px] overflow-x-auto'
        bind={bind}
        tabs={[
          'general_information',
          'learning_objectives',
          'feedback'
        ]}
      >
        {dataForm ? (
          <GeneralInformationEnad
            onsuccess={getData}
            dataForm={dataForm}
            id={id}
          />
        ) : (
          <></>
        )}
        {dataForm ? (
          <LearningObjectives onsuccess={getData} dataForm={dataForm} id={id} />
        ) : (
          <></>
        )}
        <div className='flex flex-col items-center justify-center h-full'>
          <Trancripts id={id}/>
        </div>
        <AvailableSoon
          messagekey='manage_files_and_documents_section'
          message2key='we_are_working_to_offer_you_the_best_experience'
        />
        <AvailableSoon
          messagekey='superpowers_usage_history_description'
          message2key='check_this_section_to_keep_a_clear_record_and_continue_boosting_your_skills'
        />
      </TabsComponent>
    </ScreenViewEdit>
  );
};

export const ClassENADModal = ({ disabled, onGroupCreated, className, ButtonOpen, textButton = "b_shaia_rub_create_course" }) => {
  const { openModal, bind, closeModal } = useModal();
  const { t } = useTranslation();
  const { config, user } = useSwitchInstitution({ config: configuration });
  const handleonsuccess = (optionsModal) => (res) => {
    if (res?.id) {
      onGroupCreated?.(res);
      optionsModal?.show('group_created');
      closeModal();
    }
  };
  //Esta line es por si acaso, pero para poder abrir esta modal el usuario ya debera existir
  if (!user) return <SkeletonClass />;
  return (
    <>
      <ButtonOpen {...{
        typeB: 'button',
        onClick: openModal,
        variant: 'primary',
        disabled: disabled,
        className: '',
        label: t(textButton)
      }} />
      <Modal
        customClass={classNames(
          'max-h-[700px] w-90/100 h-90/100 max-w-[1000px] overflow-hidden flex !p-0',
          className
        )}
        {...bind}
      >
        <div className='bg-DarkBlue-700/90 flex max-h-[700px] overflow-hidden flex-col pb-4'>
          <div className='flex flex-1 overflow-hidden'>
            <GroupEnad config={config} onsuccess={handleonsuccess} />
          </div>
          <div className='flex w-full justify-end px-4'>
            <Button
              label={t('close')}
              variant='primary-outline'
              typeB='button'
              className={'w-[100px]'}
              onClick={closeModal}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

/********************ENAD******************/

/*******************************BC */

export const ModalObjectivesBC = ({ methods, afterAppend, addObjectives }) => {
  return (
    <ModalObjectives
      Form={(props) => (
        <div className='min-h-[450px] min-w-[500px]'>
          <ObjectivesFormT1
            {...props}
            methods={methods}
            addObjectives={addObjectives}
          />
        </div>
      )}
      {...{ afterAppend }}
    />
  );
};

/**
 * Componente para mostrar la vista de objetivos
 * @param {*} param0
 * @returns
 */
export const FormViewGroupObjetivesBC = ({
  methods,
  arrayFields,
  forceSubmit,
}) => {
  const { removeobjetivesOptions, addObjectives, objetivesOptions } =
    useFormGroupObjectives({ arrayFields, methods });

  const _removeobjetivesOptions = (id) => {
    removeobjetivesOptions(id);
    forceSubmit();
  };

  return (
    <>
      <div>
        <div className='grid gap-[16px] mt-8'>
          <div className='flex justify-between'>
            <HeaderInputComponent labelkey='objectives_defined_for_this_group' />
            <ModalObjectivesBC
              afterAppend={forceSubmit}
              methods={methods}
              addObjectives={addObjectives}
            />
          </div>
          {objetivesOptions?.map((option, index) => {
            return (
              <CardObjective
                key={index}
                option={option}
                removeobjetivesOptions={_removeobjetivesOptions}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

/**
 * Paso 1 del formulario de creacion de curso bc
 * @param {*} param0
 * @returns
 */
export const FormGroupBCStep1 = ({
  methods,
  readonly = false,
  labelskeys = {},
}) => {
  const {
    general_select_level = 'general_select_level',
    bc_student_language_levels_according_to_cefr = 'bc_student_language_levels_according_to_cefr',
    bc_intermediate_english_levels_rubric_according_to_cefr = 'bc_intermediate_english_levels_rubric_according_to_cefr',
  } = labelskeys;
  const { t } = useTranslation();
  const { config } = useSwitchInstitution({ config: configuration });
  return (
    <GeneralFormT1
      methods={methods}
      customs={[
        null,
        <SelectableInput
          rules={{ required: t('campo_requerido') }}
          placeHolder={t(general_select_level)}
          label={t(bc_student_language_levels_according_to_cefr)}
          labelInstruction={
            bc_intermediate_english_levels_rubric_according_to_cefr
          }
          name={'levels'}
          isCreatable={false}
          formatOptionLabel={(i) => <LevelsEnglishViewer {...i}/> }
          isMulti
          options={config?.options?.optionsLevels}
          readonly={readonly}
          viewmode={readonly}
        />,
      ]}
      readonly={readonly}
    />
  );
};

/**
 * Paso 1 del formulario de creacion de curso bc
 * @param {*} param0
 * @returns
 */
export const FormGroupBCStep2 = ({ methods, arrayFields, ButtonsControls }) => {
  const { t, removeobjetivesOptions, addObjectives, objetivesOptions } =
    useFormGroupObjectives({ arrayFields, methods });
  return (
    <>
      <div>
        <ObjectivesFormT1 methods={methods} addObjectives={addObjectives} />
        <div className='grid gap-[16px] mt-4'>
          {objetivesOptions.length ? (
            <div className='text-Yellow-300 py-[5px] font-bold text-[18px] px-[8px] border-0 border-l-4 border-Yellow-300'>
              {t('added_objectives')}
            </div>
          ) : null}
          {objetivesOptions.map((option, index) => {
            return (
              <CardObjective
                key={index}
                option={option}
                removeobjetivesOptions={removeobjetivesOptions}
              />
            );
          })}
        </div>
      </div>
      <ButtonsControls hiddenskip={true} />
    </>
  );
};

/**
 * Formulario de creacion de curso bc
 * @param {*} param0
 * @returns
 */
export const FormClassBC = ({ currentStep, nextStep, prevStep, onsuccess }) => {
  const { loading, send } = useMutationCourse({
    createbody: createbodybc,
    onsuccess,
  });
  const methods = useForm({ mode: 'onBlur' });

  const fieldArrayObjetivesOptions = useFieldArray({
    control: methods.control,
    name: 'objetivesOptions',
  });

  const arrayFields = useMemo(
    () => ({ fieldArrayObjetivesOptions }),
    [fieldArrayObjetivesOptions]
  );

  const valuesForm = methods.watch();

  const disabledStep1 = useMemo(() => {
    const {
      asignature,
      calendario,
      name,
      studentsNumber,
      institution,
      levels,
      resources,
    } = valuesForm;
    return (
      !calendario?.length ||
      !name ||
      !studentsNumber ||
      !institution?.value ||
      !levels?.length ||
      !asignature?.value ||
      !resources?.length
    );
  }, [valuesForm]);

  const { t } = useTranslation();

  /* Ir a el siguiente paso */
  const handleNextStep = (evt) => {
    methods.trigger().then(() => {
      if (!Object.keys(methods.formState.errors)?.length) nextStep(evt);
    });
  };

  //Enviar el formulario
  const handleOnsubmit = () => {
    methods.handleSubmit(send)();
  };

  return (
    <FormProvider {...methods}>
      <form className='w-full'>
        {currentStep === 1 ? (
          <>
            <FormGroupBCStep1 methods={methods} />
            <div className='flex justify-center mt-4'>
              <Button
                label={t('next')}
                variant='primary'
                typeB='button'
                disabled={disabledStep1}
                onClick={handleNextStep}
              />
            </div>
          </>
        ) : null}
        {currentStep === 2 ? (
          <FormGroupBCStep2
            ButtonsControls={({ hiddenskip, disabledButtons }) => (
              <>
                <div className='sm:grid md:flex flex-wrap mt-4'>
                  <div className='hidden md:block flex-1'></div>
                  <div className='flex flex-1 justify-center gap-[16px]'>
                    <Button
                      label={t('previous')}
                      variant='primary-outline'
                      typeB='button'
                      disabled={disabledButtons}
                      onClick={prevStep}
                    />
                    <Button
                      label={t('bc_profile_create_course')}
                      variant='primary'
                      typeB={'button'}
                      onClick={handleOnsubmit}
                      disabled={
                        loading ||
                        disabledButtons ||
                        !fieldArrayObjetivesOptions?.fields?.length
                      }
                    />
                  </div>
                  <div className='flex flex-1 justify-center md:justify-end py-[8px] md:py-[0px]'>
                    {!hiddenskip ? (
                      <Button
                        label={t('skip_and_create_group')}
                        variant='primary'
                        disabled={disabledButtons}
                      />
                    ) : null}
                  </div>
                </div>
              </>
            )}
            methods={methods}
            arrayFields={arrayFields}
          />
        ) : null}
      </form>
    </FormProvider>
  );
};

export const LearningObjectivesBC = ({ onsuccess, dataForm, id }) => {
  const { send } = useMutationCourse({
    createbody: createbodybc,
    defaultreadonly: true,
    onsuccess:
      ({ changeReadOnly: _changeReadOnly, show }) =>
        () => {
          _changeReadOnly();
          show('success');
          onsuccess();
        },
    useid: true,
    mutationFn: updateClassProfileJson,
  });
  const methods = useForm({ mode: 'onBlur' });
  const { reset } = methods;

  const fieldArrayObjetivesOptions = useFieldArray({
    control: methods.control,
    name: 'objetivesOptions',
  });

  useEffect(() => {
    reset(dataForm);
  }, [dataForm, reset]);

  const _send = (data) => {
    send({ id, ...data });
  };

  const forceSubmit = () => {
    methods.handleSubmit(_send)();
  };

  const arrayFields = useMemo(
    () => ({ fieldArrayObjetivesOptions }),
    [fieldArrayObjetivesOptions]
  );

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(_send)} className='w-full'>
        <FormViewGroupObjetivesBC
          methods={methods}
          dataForm={dataForm}
          forceSubmit={forceSubmit}
          arrayFields={arrayFields}
        />
      </form>
    </FormProvider>
  );
};

/**
 * View Edit Group para el perfil de grupo enad
 * @returns
 */
export const ViewEditBC = () => {
  const { bind } = useTabsComponent({ defaultIndex: 0 });
  const { mutate, dataForm, isLoading, isError, config } =
    useMutationGetClassProfile({
      config: configuration,
      dataToFormDatafn: dataToFormDataBC,
    });
  const { id } = useUtilsNavigation({});

  // Se obtiene la informacion del grupo
  const getData = useCallback(() => {
    if (id && config) {
      mutate({ id });
    }
  }, [id, mutate, config]);

  useEffect(() => {
    getData();
  }, [getData]);

  if (isError && !isLoading)
    return <h1>Error, No se puedo obtener el recuso</h1>;

  return (
    <ScreenViewEdit>
      <HeaderScreenPath
        labelkey='perfil_de_curso_mis_cursos'
        path='/course-profile'
        name={dataForm?.name}
      />
      <TabsComponent
        customClassTabList='min-w-[700px] overflow-x-auto'
        bind={bind}
        tabs={[
          'general_information',
          'learning_objectives',
          'feedback',
          'superpowers_usage_history',
        ]}
      >
        {dataForm ? (
          <GeneralInformationBC
            onsuccess={getData}
            dataForm={dataForm}
            id={id}
          />
        ) : (
          <></>
        )}
        {dataForm ? (
          <LearningObjectivesBC
            onsuccess={getData}
            dataForm={dataForm}
            id={id}
          />
        ) : (
          <></>
        )}
        <AvailableSoon
          messagekey='manage_files_and_documents_section'
          message2key='we_are_working_to_offer_you_the_best_experience'
        />
        <AvailableSoon
          messagekey='superpowers_usage_history_description'
          message2key='check_this_section_to_keep_a_clear_record_and_continue_boosting_your_skills'
        />
      </TabsComponent>
    </ScreenViewEdit>
  );
};

/**
 * Pantalla de creacion de curso bc
 * @param {*} param0
 * @returns
 */
export const ClassBC = ({ config, onsuccess }) => {
  const { bind, currentStep, setCurrentStep } = useStepIndicator({
    steps: 2,
    steplong: 'w-[40px]',
  });
  const { type, t } = useUtilsNavigation({ menu: config?.menu });

  const handleNextStep = (step) => () => {
    setCurrentStep(currentStep + step);
  };

  return (
    <ScreenForm>
      <HeaderFormWithSteps
        step={currentStep}
        bindstep={bind}
        option={t('course').toLowerCase()}
      />
      <FormClassBC
        type={type}
        currentStep={currentStep}
        prevStep={handleNextStep(-1)}
        nextStep={handleNextStep(1)}
        onsuccess={onsuccess}
      />
    </ScreenForm>
  );
};

export const ClassBCModal = ({ disabled, onGroupCreated, className, buttonClassName, customActionTextLabel}) => {
  const { openModal, bind, closeModal } = useModal();
  const { t } = useTranslation();
  const { config, user } = useSwitchInstitution({ config: configuration });
  const handleonsuccess = (optionsModal) => (res) => {
    if (res?.id) {
      onGroupCreated?.(res);
      optionsModal?.show('group_created');
      closeModal();
    }
  };

  const renderActionElement = () => {
    if (customActionTextLabel)
      return (
        <span
          onClick={openModal}
          className="text-shaiaBlue font-bold cursor-pointer"
        >
          {t(customActionTextLabel)}
        </span>
      );
    return (
      <Button
        typeB={"button"}
        onClick={openModal}
        variant={"primary"}
        disabled={disabled}
        className={classNames("w-full", buttonClassName)}
        label={t("b_shaia_rub_create_course")}
      />
    );
  };
  
  //Esta line es por si acaso, pero para poder abrir esta modal el usuario ya debera existir
  if (!user) return <SkeletonClass />;
  return (
    <>
      {renderActionElement()}
      <Modal
        customClass={classNames(
          'max-h-[700px] w-90/100 h-90/100 max-w-[1000px] overflow-hidden flex !p-0',
          className
        )}
        {...bind}
      >
        <div className='bg-DarkBlue-700/90 flex max-h-[700px] overflow-hidden flex-col pb-4'>
          <div className='flex flex-1 overflow-hidden'>
            <ClassBC isModal config={config} onsuccess={handleonsuccess} />
          </div>
          <div className='flex w-full justify-end px-4'>
            <Button
              label={t('close')}
              variant='primary-outline'
              typeB='button'
              className={'w-[100px]'}
              onClick={closeModal}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

/*******************************BC */

/**
 * Screen para el perfil generico
 * @returns
 */
export const GenericTeacherProfile = () => {
  const { type, navigate } = useUtilsNavigation();
  const { config, institution, user } = useSwitchInstitution({
    config: configuration,
  });
  if (!user) return <SkeletonClass />;
  // Si no hay tipo, se muestra el selector
  //Se proteje el componente, para que solo se puede acessar a el si el usuario esta logueado
  if (!type) {
    if (institution?.uniquecode === 'FAAQ')
      return <SelectType menu={config?.menu} />;
    else if (institution?.uniquecode === 'BC')
      return navigate('/my-classes/coursebc');
    else return navigate('/my-classes/notfound');
  }
  if (type === 'group' && institution?.uniquecode === 'FAAQ')
    return <GroupEnad config={config} />;
  if (type === 'course') return navigate('/course-profile?create');
  if (type === 'coursebc') return <ClassBC config={config} />;
  if (type === 'notfound') return <NotFound />;
  return navigate('/my-classes');
};

export const ViewEditDetails = () => {
  const { navigate } = useUtilsNavigation();
  const { institution, user } = useSwitchInstitution({ config: configuration });
  if (!user) return <SkeletonClass />;
  if (institution?.uniquecode === 'BC') return <ViewEditBC />;
  return navigate('/course-profile');
};
